import { useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ChatSurface } from '../components/chat/ChatSurface';

/**
 * The `/chat` route. Session identity comes from the URL here; every other
 * host of `ChatSurface` binds it another way (app-shell ADR-013).
 */
export function ChatView() {
  const { sessionId } = useParams<{ sessionId: string }>();
  const navigate = useNavigate();

  const openSession = useCallback(
    (id: string) => void navigate(`/chat/${id}`),
    [navigate],
  );
  const leaveMissingSession = useCallback(
    () => void navigate('/chat', { replace: true }),
    [navigate],
  );

  return (
    <ChatSurface
      sessionId={sessionId}
      onOpenSession={openSession}
      onSessionCreated={openSession}
      onSessionMissing={leaveMissingSession}
    />
  );
}
